import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash.get';

import { Link } from 'acq-components/lib/base-components/Link/Link';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import { createDtmHandler } from 'src/universal/utils/analyticsTracking';
import textRemoveTags from 'service_modules/utils/text-remove-tags';

import { getPdpLinks, getCardWithPznData } from 'page_modules/business-pdp/redux';

import defaultStyles from './__styles__/index.scss?modules';

const TcLinks = React.memo(
  ({ links, styles = defaultStyles, parent = '', customKeys, cardData }) => {
    const keyList =
      Array.isArray(customKeys) && customKeys.length > 0
        ? customKeys
        : ['offerTerms', 'ratesFees'];
    return (
      <div className={styles.tcLinks}>
        {keyList.map((linkType = '', key) => {
          const dtmObj = get(links, `${linkType}.dtm`)
            ? {
                ...links[linkType].dtm,
                eventAsset: `${links[linkType].dtm.eventAsset}_${parent}`
              }
            : {};
          const text = links?.[linkType]?.text ?? '';
          return (
            <Link
              href={get(links, `${linkType}.url`) || ''}
              onClick={createDtmHandler({
                dtmObj
              })}
              target="_blank"
              key={`tclink${key}`}
              aria-label={`${textRemoveTags(text)} for ${textRemoveTags(
                cardData.cardHeadline
              )}`}
            >
              <Sanitizer
                Component="div"
                className={styles[linkType]}
                safelySetInnerHTML={text}
              />
            </Link>
          );
        })}
      </div>
    );
  }
);

const mapStateToProps = (state, ownProps) => {
  const urlEep = get(ownProps, 'params.eep') || '';
  return {
    links: getPdpLinks(urlEep)(state),
    cardData: getCardWithPznData(state)
  };
};

export default withRouter(connect(mapStateToProps)(TcLinks));
